import styled, { css } from 'styled-components';
import {
    BUTTON_CONTENT_BASE,
    CONTENT_BASE,
    CONTENT_DISABLED,
    PRIMARY_BASE,
    PRIMARY_HOVER,
    PRIMARY_MUTED,
    PRIMARY_PRESS,
    TERTIARY_BORDER,
    TERTIARY_BACKGROUND,
} from '@amzn/ring-common-style-library/lib/colors';
import { BODY_LARGE_MEDIUM, BODY_SMALL_MEDIUM } from '@amzn/ring-common-style-library/lib/typography';
import { RatingStarIcon } from '../Icon';

const MultiSelectWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const Title = styled.div`
    ${BODY_LARGE_MEDIUM};
    color: ${CONTENT_BASE};
    margin: 0;
`;

const Subtitle = styled.div`
    ${BODY_SMALL_MEDIUM};
    color: ${CONTENT_BASE};
    margin: 0;
`;

const ItemsContainer = styled.div<{ feedback: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 8px;
    ${({ feedback }) =>
        feedback && css`
            padding-left: 8px;
            border-left: 1px solid ${TERTIARY_BORDER};
        `}
`;

const ItemWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const Item = styled.div`
    width: fit-content;
    max-width: 300px;
`;

const RatingContainer = styled.div`
    display: flex;
    gap: 8px;
`;

const SubmitButton = styled.div`
    width: fit-content;
    max-width: 300px;
    margin-top: 8px;
`;

const ratingButtonStates = css<{ disabled?: boolean; selected?: boolean }>`
    border: 1px solid ${TERTIARY_BACKGROUND};
    background: ${BUTTON_CONTENT_BASE};
    color: ${CONTENT_BASE};

    ${RatingStarIcon} {
        fill: none;
        stroke: ${CONTENT_BASE};
    }

    ${({ disabled, selected }) =>
        disabled &&
        selected &&
        css`
            background: ${PRIMARY_PRESS};
            border: 1px solid ${PRIMARY_BASE};
            color: ${CONTENT_DISABLED};
            ${RatingStarIcon} {
                stroke: ${CONTENT_DISABLED};
            }
        `}

    /* Disabled but not selected */
    ${({ disabled, selected }) =>
        disabled &&
        !selected &&
        css`
            background: ${TERTIARY_BACKGROUND};
            color: ${CONTENT_DISABLED};
            cursor: not-allowed;
            ${RatingStarIcon} {
                stroke: ${CONTENT_DISABLED};
            }
        `}

    /* Not disabled: hover/active states */
    ${({ disabled }) =>
        !disabled &&
        css`
            &:hover {
                background: ${BUTTON_CONTENT_BASE};
                border: 1px solid ${PRIMARY_HOVER};
                color: ${PRIMARY_HOVER};
                ${RatingStarIcon} {
                    stroke: ${PRIMARY_HOVER};
                }
            }
            &:active {
                background: ${PRIMARY_PRESS};
                border: 1px solid ${PRIMARY_BASE};
                color: ${PRIMARY_MUTED};
                ${RatingStarIcon} {
                    stroke: ${PRIMARY_MUTED};
                }
            }
        `}

    /* Not disabled and selected */
    ${({ disabled, selected }) =>
        !disabled &&
        selected &&
        css`
            background: ${PRIMARY_PRESS};
            border: 1px solid ${PRIMARY_BASE};
            ${RatingStarIcon} {
                stroke: ${PRIMARY_MUTED};
                fill: ${PRIMARY_MUTED};
            }
        `}
`;

const RatingButton = styled.button<{
    disabled?: boolean;
    selected?: boolean;
}>`
    display: flex;
    padding: 8px 12px;
    justify-content: center;
    align-items: center;

    ${ratingButtonStates}
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

    border-radius: 8px; 
`;

export default {
    MultiSelectWrapper,
    Title,
    Subtitle,
    Item,
    ItemsContainer,
    ItemWrapper,
    RatingButton,
    RatingContainer,
    SubmitButton,
};
